import MemberCanvas from "../../components/3d/MemberCanvas";
import { useState, useEffect, useRef, useCallback } from "react";
import { Canvas } from "@react-three/fiber";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import { resourceLoader } from "../../utils/resourceLoader";

function Members(props) {
  const [shouldFullScreenShow, setshouldFullScreenShow] = useState(false);
  const membersRef = useRef(null);
  const touchStartYRef = useRef(0);
  const touchStartTimeRef = useRef(0);
  const scrollThreshold = 50;
  const [isVisible, setIsVisible] = useState(false);
  const [is3DVisible, setIs3DVisible] = useState(false);
  const [is3DLoaded, setIs3DLoaded] = useState(false);

  useEffect(() => {
    if (shouldFullScreenShow) {
      props.locker(true);
    } else {
      props.locker(false);
    }
  }, [shouldFullScreenShow]);

  const isMembersContentFullyVisible = useCallback(() => {
    if (!membersRef.current) return false;
    const rect = membersRef.current.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= 10;
  }, []);

  const handleWheel = useCallback(
    (e) => {
      if (shouldFullScreenShow) return;

      const isScrollingUp = e.deltaY < 0;

      if (isScrollingUp) {
        if (isMembersContentFullyVisible()) {
          props.locker(false);
        } else {
          props.locker(true);

          e.stopPropagation();
        }
      } else {
        props.locker(true);
        e.stopPropagation();
      }
    },
    [isMembersContentFullyVisible, props.locker, shouldFullScreenShow],
  );

  const handleTouchStart = useCallback(
    (e) => {
      if (shouldFullScreenShow) return;

      touchStartYRef.current = e.touches[0].clientY;
      touchStartTimeRef.current = Date.now();
    },
    [shouldFullScreenShow],
  );

  const handleTouchMove = useCallback(
    (e) => {
      if (shouldFullScreenShow) return;

      const touchY = e.touches[0].clientY;
      const deltaY = touchY - touchStartYRef.current;

      if (Math.abs(deltaY) > 10) {
        if (deltaY < 0) {
          props.locker(true);
          e.stopPropagation();
        } else {
          if (isMembersContentFullyVisible()) {
            props.locker(false);
          } else {
            props.locker(true);
            e.stopPropagation();
          }
        }
      }
    },
    [isMembersContentFullyVisible, props.locker, shouldFullScreenShow],
  );

  const handleTouchEnd = useCallback(
    (e) => {
      if (shouldFullScreenShow) return;

      const touchEndY = e.changedTouches[0].clientY;
      const deltaY = touchEndY - touchStartYRef.current;
      const touchDuration = Date.now() - touchStartTimeRef.current;

      if (Math.abs(deltaY) > scrollThreshold && touchDuration < 300) {
        if (deltaY < 0) {
          props.locker(true);
          e.stopPropagation();
        } else {
          if (isMembersContentFullyVisible()) {
            props.locker(false);
          } else {
            props.locker(true);

            e.stopPropagation();
          }
        }
      }
    },
    [isMembersContentFullyVisible, props.locker, shouldFullScreenShow],
  );

  useEffect(() => {
    const container = membersRef.current;
    if (!container) return;

    container.addEventListener("wheel", handleWheel, { passive: false });
    container.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    container.addEventListener("touchmove", handleTouchMove, {
      passive: false,
    });
    container.addEventListener("touchend", handleTouchEnd);

    return () => {
      container.removeEventListener("wheel", handleWheel);
      container.removeEventListener("touchstart", handleTouchStart);
      container.removeEventListener("touchmove", handleTouchMove);
      container.removeEventListener("touchend", handleTouchEnd);
    };
  }, [handleWheel, handleTouchStart, handleTouchMove, handleTouchEnd]);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true);
      setTimeout(() => {
        setIs3DVisible(true);
      }, 500);
    });
  }, []);

  return (
    <div
      ref={membersRef}
      className="home-members"
      style={{
        backgroundImage: `url(${resourceLoader.getResource("3d.sky.stars_north").url})`,
      }}
    >
      <div className="home-members-content">
        <div className="home-members-3dcanvas-container">
          <div
            className="home-members-3dcanvas"
            onClick={() =>
              shouldFullScreenShow ? "" : setshouldFullScreenShow(true)
            }
            style={{ opacity: isVisible ? 1 : 0 }}
          >
            <div
              className="home-members-3dcanvas-positionc"
              style={{
                pointerEvents: shouldFullScreenShow ? "inherit" : "none",
                position: shouldFullScreenShow ? "absolute" : "relative",
                zIndex: shouldFullScreenShow ? 4000 : "inherit",
              }}
            >
              <button
                className="home-members-3dcanvas-close"
                onClick={() => setshouldFullScreenShow(false)}
                style={{ opacity: shouldFullScreenShow ? 1 : 0 }}
              >
                <i className="fas fa-angle-left"></i>
                返回
              </button>
              <ErrorBoundary>
                {is3DVisible && (
                  <MemberCanvas setLoaded={setIs3DLoaded}></MemberCanvas>
                )}
              </ErrorBoundary>
            </div>
          </div>
          <div className="home-members-3dcanvas-in">
            {!is3DLoaded ? "加载中，这可能需要几秒" : "点击进入交互模式"}
          </div>
        </div>
        <div
          className="home-members-decriptions-container"
          style={{
            transform: isVisible ? "translateX(0px)" : "translateX(100vw)",
          }}
        >
          <div className="home-members-decriptions-title">成员 | MEMBERS</div>
          <div className="home-members-descriptions-line"></div>
          <div className="home-members-descriptions-1">
            在同一片星空下，我们彼此相遇
          </div>
          <div className="home-members-descriptions-2">
            赠予曾经，现在，未来的我们
          </div>
        </div>
      </div>
      <div className="home-friendshiplink">
        <div className="home-friendshiplink-title-container">
          <p className="home-friendshiplink-title">
            <i className="fas fa-link"></i>&nbsp;友情链接
          </p>
          <p className="home-friendshiplink-subtitle">FRIENDSHIP LINKS</p>
        </div>
        <div className="home-friendshiplink-content">
          <a href="https://www.tianmc.top/" rel="noreferrer" target="_blank" className="home-friendshiplink-card">
            <div className="home-friendshiplink-card-icon"
              style={{
                backgroundImage:
                  "linear-gradient(to bottom right, #34d399, #059669)",
                borderRadius: "0.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 15px -3px rgba(16, 185, 129, 0.2)",
                color:"white",
                fontSize:"1.3rem",
                fontWeight:"bold"
              }}
            >T</div>
            <div className="home-friendshiplink-card-info">
              <div className="home-friendshiplink-card-info-title">Tian服</div>
              <div className="home-friendshiplink-card-info-description">咱现在在玩的服务器</div>

            </div>
          </a>
        </div>
      </div>
      <div className="home-members-footer">
        <div className="footer-container-1">
          <div className="footer-logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              className="footer-logo-icon"
            >
              <defs>
                <style>
                  {`
            .st0, .st1, .st2, .st3 {
              stroke:#ffefd5;
              stroke-miterlimit: 10;
            }
            .st0, .st3 {
              fill: none;
            }
            .st1 {
              fill: #000;
            }
            .st2{
              fill:#ffefd5;
            }
            .st3 {
              stroke-linecap: round;
            }
          `}
                </style>
              </defs>

              <path className="st1" d="M-11.25-44.03" />
              <g>
                <path className="st0" d="M13.96,1.26" />
                <polyline
                  className="st0"
                  points="7.85 13.9 13.42 11.82 13.42 5.49 8.06 7.46"
                />
                <polyline
                  className="st0"
                  points="2.77 7.76 2.77 5.64 7.9 7.5"
                />
                <line className="st0" x1="2.77" y1="8.59" x2="2.77" y2="7.51" />
                <line
                  className="st0"
                  x1="2.77"
                  y1="10.06"
                  x2="2.77"
                  y2="8.59"
                />
                <polyline
                  className="st0"
                  points="8.21 13.9 2.77 11.75 2.77 10.06"
                />
                <line className="st3" x1="8.12" y1="7.51" x2="8.12" y2="13.8" />
                <line
                  className="st3"
                  x1="8.04"
                  y1="2.71"
                  x2="13.42"
                  y2="4.83"
                />
                <line className="st3" x1="7.94" y1="2.68" x2="2.76" y2="4.97" />
                <polygon
                  className="st2"
                  points="8.54 13.46 13.3 11.56 13.24 5.56 8.44 7.44 8.54 13.46"
                />
                <polygon
                  className="st2"
                  points="4.33 10.49 6.36 11.31 6.39 8.58 4.3 7.79 4.33 10.49"
                />
              </g>
            </svg>
            <p className="footer-logo-name">天地源</p>
          </div>
          <div className="footer-container-2">
            <div className="footer-functionarea">
              <a className="footer-link" href="#index">
                返回首页
              </a>
              <div className="footer-link-divider">|</div>
              <a className="footer-link" href="https://qm.qq.com/q/ODELlFJ7cQ">
                加入我们
              </a>
              <div className="footer-link-divider">|</div>
              <a className="footer-link" href="a">
                更多...
              </a>
            </div>
            <div className="footer-divider"></div>
            <div className="footer-copyright">
              开发者：OR起源 <br />
              Copyright ©2026 天地源公会
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Members;
